import { useGraphQLQuery } from './useGQLQuery';

export { useGraphQLQuery };
